import { LoginManager } from '@utils/auth/loginManager';
import { IdentifyCurrentUserQueryResult } from '@utils/auth/auth.types';
import { BLISS_GATEWAY_ROOT_URL } from '@utils/urlHelpers.util';
import { ME_QUERY } from './queries';

export class AuthApi {
  private _loginManager: LoginManager;

  state: { isLoading: boolean } = {
    isLoading: false,
  };

  constructor(loginManager: LoginManager) {
    this._loginManager = loginManager;
  }

  async identifyCurrentUser(eventId: Maybe<string>): Promise<IdentifyCurrentUserQueryResult> {
    this._setIsLoading(true);
    return fetch(BLISS_GATEWAY_ROOT_URL + '/graphql', {
      method: 'POST',
      headers: {
        'Accept-Encoding': 'gzip, deflate, br',
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Connection: 'keep-alive',
        Origin: BLISS_GATEWAY_ROOT_URL,
        authorization: this._getAuthHeaderValue(),
      },
      body: JSON.stringify({
        operationName: 'GetMeMarcom',
        query: ME_QUERY,
        variables: {
          eventId,
          withActiveEventUser: !!eventId,
        },
      }),
    })
      .then(resp => {
        return resp.json();
      })
      .finally(() => {
        this._setIsLoading(false);
      });
  }

  private _getAuthHeaderValue() {
    const token = this._loginManager.getToken();
    return token ? `Bearer ${token}` : '';
  }

  private _setIsLoading(isLoading: boolean) {
    this.state.isLoading = isLoading;
  }
}
